<template>
  <div v-if="hasNewHeader()">
    <router-view/>
    <div @click.prevent="btnClick"  class="text-center"  id="btn-scroll">
      <i class="fa-regular fa-square-caret-up"></i>
    </div>
  </div>
  <div v-if="!hasNewHeader()">
    <NavBar v-if="showNavBar"/>
    <div :class="shownavBarStyel">
      <router-view/>
      <div @click.prevent="btnClick"  class="text-center"  id="btn-scroll">
        <i class="fa-regular fa-square-caret-up"></i>
      </div>
      <!-- <button
        v-show="isVisible"
        @click="scrollToTop"
        class="scroll-top"
        aria-label="Scroll to top"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M12 8.59L16.59 13 18 11.59 12 5.59 6 11.59 7.41 13z"/>
        </svg>
      </button> -->
    </div>
  </div>
  <FooterBar v-if="showFooterBar" />
</template>

<script>
import FooterBar from './components/FooterBar.vue';
import NavBar from './components/NavBar.vue';

// let btnUp = document.getElementById('btn-scroll');
window.onscroll = function (){
  // console.log(this.scrollY);
  this.scrollY > 400 ? document.getElementById('btn-scroll').classList.add('show') :  document.getElementById('btn-scroll').classList.remove('show');
  // console.log(btnUp);
  
}

export default {
  data(){
    return {
      isVisible: false,
    }
  },
  components:{
    NavBar,
    FooterBar,
  },

  computed:{
    currentRouterName(){
      return this.$route.name;
    },

    showNavBar(){
      return(
        !['PaymentFailed','PaymentSuccess','Page404'].includes(this.currentRouterName)
      )
    },

    showFooterBar(){
      return (
        !['PaymentFailed','PaymentSuccess','Page404'].includes(this.currentRouterName)
      )
    },
    shownavBarStyel(){
      return (
        [''].includes(this.currentRouterName) ? '' : 'content-body flex-fill content-Mobile'
      )
    }
  },

  methods: {
    // handleScroll() {
    //   this.isVisible = window.scrollY > 300;
    //   // console.log('dsfsdfsdffsdfssdfs');
    //   // console.log(window.scrollY);
      
    // },
    // scrollToTop() {
    //   window.scrollTo({ top: 0, behavior: "smooth" });
    // },
    // contentBody(){
    //   return !['AboutUs'].includes(this.currentRouterName)? 'content-body' : '';
    // }
    // checkScroll() {
    //   const btn = document.getElementById('scrollTopBtn');
    //   // console.log(btn);
    //   if(!btn){
    //     return ;
    //   }
      
    //   if (window.scrollY > 300) {
    //     btn.classList.add('show');
    //   } else {
    //     btn.classList.remove('show');
    //   }
    // },

    // scrollToTop() {
    //   const supportsSmooth = 'scrollBehavior' in document.documentElement.style;
    //   const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    //   if (reduceMotion || !supportsSmooth) {
    //     window.scrollTo(0, 0);
    //   } else {
    //     window.scrollTo({ top: 0, behavior: 'smooth' });
    //   }
    // },

    btnClick(){
      scrollTo({
        top:0,
        behavior:"smooth"
      });
    },
    hasNewHeader(){
      return ['PublicProfile'].includes(this.$route.name);
    },
  }
  // mounted() {
  //   // window.addEventListener("scroll", this.handleScroll);
  //   this.boundHandleScroll = this.handleScroll.bind(this);
  //   window.addEventListener("scroll", this.boundHandleScroll);

  // },
  // beforeUnmount() {
  //   window.removeEventListener("scroll", this.handleScroll);
  // },
  
}

</script>


